import "./v2-question-surface.css";

export default function SharePill({ children, copied = false, onClick, ariaLabel }) {
  return (
    <button
      className="tgc-v2-share-pill"
      type="button"
      data-copied={copied ? "true" : "false"}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      {copied ? "Copied" : children}
    </button>
  );
}
